import React, { useMemo, useState } from "react";
import { useHistory,useLocation  } from "react-router-dom";
import { useTopupMyAccountsUIContext } from "./TopupMyAccountsUIContext";
import "../../../../../_metronic/_assets/sass/pages/my-korek/my-active-offers.scss";
import { Divider } from "@material-ui/core";
import { fetchMyTopupMyAccounts } from "../../_redux/topupMyAccounts/topupMyAccountsActions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Image, Row, Col, Button, Card } from "react-bootstrap";
import "../../../../../_metronic/_assets/sass/pages/my-korek/topup-my-account.scss";
import { FormattedMessage } from "react-intl";
import { GetNasPaidStatus } from "../../_redux/rechargeLines/rechargeLinesActions";
const services = [
  {
    name: "Balance",
    amount: "4,316 IQD",
    btnName: "Add Balance",
  },
  {
    name: "Data",
    amount: "5/12 GB",
    btnName: "Add Data",
  },
  {
    name: "Voice",
    amount: "209/300 Min",
    btnName: "Add Voice",
  },
  {
    name: "Validity",
    amount: "10/40 Days",
    btnName: "Add Validity",
  },
];
const offers = [
  {
    name: "Kulish Kafi Package",
    amount: "10,000 IQD",
    src: "/media/korek/tp-offer1.png"
  },
  {
    name: "Youth offer",
    amount: "10,000 IQD",
    src: "/media/korek/tp-offer2.png"
  },
  {
    name: "Infinite",
    amount: "10,000 IQD",
    src: "/media/korek/tp-offer3.png"
  },
];


export function TopupMyAccountsCard() {
  const topupMyAccountsUIContext = useTopupMyAccountsUIContext();
  const dispatch = useDispatch()
  const location = useLocation();
  const history = useHistory();

  const topupMyAccountsUIProps = useMemo(() => {
    return {
      ids: topupMyAccountsUIContext.ids,
      queryParams: topupMyAccountsUIContext.queryParams,
      setQueryParams: topupMyAccountsUIContext.setQueryParams,
      openUpdateTopupMyAccountsStatusDialog:
        topupMyAccountsUIContext.openUpdateTopupMyAccountsStatusDialog,
      openValidity:
        topupMyAccountsUIContext.openValidity,
      openActivateBestOfferForYou:
        topupMyAccountsUIContext.openActivateBestOfferForYou,
    };
  }, [topupMyAccountsUIContext]);

  const [loading, setLoading] = useState(false);
  const [activeCategoryId, setActiveCategoryId] = useState("");


  useEffect(() => {
   
    const init = async () => {
    dispatch(fetchMyTopupMyAccounts());
    handleCategoryClick(btlOfferCategories && btlOfferCategories[0].idParam);
    
    const externalId = location.pathname.split("externalId=")[1];
    if (externalId) {
      console.log("externalUd",externalId)
      await dispatch(GetNasPaidStatus({ id: externalId }));
      history.push("/my-korek/topup-my-account");
    }
    };

    init();
  }, []);



  const btlOfferCategories = useSelector(
    (state) => state.profileSlice.btlOfferCategories,
    shallowEqual
  );

  const handleCategoryClick = (categoryId) => {
    setActiveCategoryId(categoryId);

  };
  const { currentState } = useSelector(
    (state) => ({ currentState: state.topupMyAccounts }),
    shallowEqual
  );
  const { accountItems, bestOffersForYou } = currentState;
  useEffect(() => {
    bestOffersForYou && handleCategoryClick("");
  }, [bestOffersForYou]);
  return (
    <div className="topup-my-account mx-3 pb-5">
      <Row className="gap-2">
        {accountItems && accountItems.map((x, i) => (
          <Col
            className={
              i == 0
                ? "box mr-2 my-2"
                : i == accountItems.length - 1
                  ? "box ml-2 my-2"
                  : "box mx-2 my-2"
            }
          >
            <Image className="mx-auto" src={"/media/korek/topup-" + x.idType + ".png"}></Image>
            <br />
            <p className="upper">{x.itemName}</p>{" "}
            <p className="lower">{x.itemValue}</p>
            {/* <Button className="btn btn-small btn-warning"> */}
            <a href={x.idType == "4" ? "/my-korek/validity" : x.idType == "1" ? "/my-korek/recharge-line" : ""} className="btn btn-small btn-warning">
              <b><FormattedMessage id="TOP_UP.BEST_OF_FOR_YOU.ADD"></FormattedMessage>{" " + x.itemName}</b></a>
            {/* </Button> */}
          </Col>
        ))}
      </Row>
      <div className="my-5 offer mx-2">
        <h4>
          <b><FormattedMessage id="TOP_UP.BEST_OF_FOR_YOU"></FormattedMessage></b>
        </h4>
        {bestOffersForYou && 
        <Row className="g-3" style={{ justifyContent: "center" }}>
         {btlOfferCategories  &&
          <Col className="my-3" xs={6} sm={6} md={4} lg={3} xl={3} xxl={3}>
              <Card
                // aria-disabled={loading}
                className={`category-card bg-white ${activeCategoryId === ""   ? 'active' : ''} ${loading ? 'disabled-card' : ''}`}
                onClick={() => handleCategoryClick("")}
                style={{ width: '100%', cursor: 'pointer' }}
              >
                <Card.Body className="text-center p-5">
                  <div className="slide-bundles">
                    <svg viewBox="0 0 1 1" style={{
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      width: "100%",
                      height: "50px",
                      backgroundSize: "contain",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      backgroundImage: `url("/media/korek/All.png")`
                    }}></svg>
                  </div>
                  <Card.Title className={`category-name mb-0 pt-5 ${activeCategoryId === "" ? 'active-text' : ''}`}>
                    <b><FormattedMessage id="KOREK_SERVICES.MY_NBR_MY_CHOICE.All"></FormattedMessage></b>
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
}

          {btlOfferCategories?.map((category, index) => (
            <Col className="my-3" xs={6} sm={6} md={4} lg={3} xl={3} xxl={3} key={index}>
              <Card
                // aria-disabled={loading}
                className={`category-card bg-white ${activeCategoryId === category.idParam ? 'active' : ''} ${loading ? 'disabled-card' : ''}`}
                onClick={() => handleCategoryClick(category.idParam)}
                style={{ width: '100%', cursor: 'pointer' }}
              >
                <Card.Body className="text-center p-5">
                  <div className="slide-bundles">
                    <svg viewBox="0 0 1 1" style={{
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      width: "100%",
                      height: "50px",
                      backgroundSize: "contain",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      backgroundImage: `url(${category.image})`
                    }}></svg>
                  </div>
                  <Card.Title className={`category-name mb-0 pt-5 ${activeCategoryId === category.idParam ? 'active-text' : ''}`}>
                    <b>{category.value}</b>
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        }
        <Row className="py-5">
            {bestOffersForYou && (
    bestOffersForYou.list.filter((y) => !activeCategoryId || y.idCategory === parseInt(activeCategoryId)).length > 0
      ? bestOffersForYou.list
          .filter((y) => !activeCategoryId || y.idCategory === parseInt(activeCategoryId))
          .map((x) => (
            <Col className="py-5" xl={4} key={x.id}>
              <Card style={{ backgroundColor: "#F8F8F8" }}>
                <Card.Img variant="top" src={x.imageUrl ? x.imageUrl : "/media/korek/tp-offer3.png"} />
                <Card.Body className="p-3 text-dark">
                  <Card.Title>
                    <Row>
                      <Col style={{ whiteSpace: "nowrap" }} className="text-dark">
                        {x.name}
                      </Col>
                      <Col className="text-primary text-right">
                        <b>{x.price}</b>
                      </Col>
                    </Row>
                  </Card.Title>
                  <Card.Text>
                    <Row>
                      <Col>
                        <Button onClick={() => topupMyAccountsUIProps.openActivateBestOfferForYou(x.idData)} className="btn btn-warning btn-small">
                          <b><FormattedMessage id="TOP_UP.ACTIVATE_OFFER" /></b>
                        </Button>
                      </Col>
                    </Row>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))
      : <Col className="text-center w-100">
          <b><FormattedMessage id="NO_DATA_FOUND" /></b>
        </Col>
  )}
        </Row>
        {bestOffersForYou && bestOffersForYou.count > 3 && <h6 className="text-primary">
          <b><FormattedMessage id="TOP_UP.LOAD_MORE_OF"></FormattedMessage></b>
        </h6>}
      </div>
    </div>
  );
}
